import { Offcanvas } from "bootstrap";

document.addEventListener('click', function (i) {
  let e = i.target.closest('a');
  if (!e || !e.hasAttribute('data-href') || !window.offCanvasNiche) return;
  i.preventDefault();
  window.offCanvasNiche(e);
});
document.addEventListener("DOMContentLoaded", () => {
  /**
   * Document on ready we will load the OffCanvasNiche function.
   */
  offCanvasOnload();
});

window.offCanvasNiche = function (e: HTMLElement) {
  let noHistory = e.classList.contains('no-history');
  let hashHistory = e.classList.contains('hash-history');

  /**
   * We get both the "data-url" and the "real-url" for refrence once.
   */
  let url = e.getAttribute('data-href'); //#offcanvas82
  let currentLocation = window.location.href.split('#')[0] ?? false;
  let realLink = e.getAttribute('href'); //https://

  /**
   * We get the current location. as this can change depending on what page the canvas in on
   * explained later why we cant use a back command.
   */
  if (!url || !realLink) return;
  /**
   * We pass in the real "href" as a push state.
   */
  if (!noHistory || hashHistory) {
    window.history.pushState({}, "", hashHistory ?
      url.split('#')[1] :
      realLink);

  }
  /**
   * Find the element refrenced as the offcanvas
   */
  let elem = document.querySelector(url);
  if (!elem) return;
  openCanvas(elem, url, currentLocation);
}

function offCanvasOnload() {
  let hash = window.location.hash ?? false;
  if (!hash) return;

  let elem = document.querySelector(hash);
  if (!elem) return;

  let currentLocation = window.location.origin + window.location.pathname;

  openCanvas(elem, hash, currentLocation);

}

function openCanvas(elem, realLink, currentLocation) {
  // console.log(elem, realLink, currentLocation);
  let oc = new Offcanvas(realLink);

  elem.addEventListener('hidden.bs.offcanvas', function () {
    /**
     * We are not going back in history as this would require i rewrite to push state.
     * asking for window.history.back() would reload the page.
     */

    window.history.pushState({}, "", currentLocation);

  });
  /**
   * Show the canvas
   */
  oc.show();
}